/** Codec `media`: escolhe o portador (PNG ou WAV) e nomeia o arquivo. */
import { decodePng, encodePng, isPng } from './png.js'
import { randomInt } from './random.js'
import { DisguiseError, MediaCarrier, type DisguisedFile } from './types.js'
import { decodeWav, encodeWav, isWav } from './wav.js'

/** Nomes triviais: um arquivo chamado `payload.png` chamaria atencao. */
function fileName(carrier: MediaCarrier): string {
  const stamp = 20_240_000 + randomInt(9999)
  return carrier === MediaCarrier.Png ? `IMG_${stamp}.png` : `AUD_${stamp}.wav`
}

export function encodeMedia(payload: Uint8Array, carrier: MediaCarrier): DisguisedFile {
  const bytes = carrier === MediaCarrier.Png ? encodePng(payload) : encodeWav(payload)
  return {
    kind: 'media',
    transport: 'document',
    bytes,
    mimeType: carrier === MediaCarrier.Png ? 'image/png' : 'audio/wav',
    fileName: fileName(carrier),
    carrier,
  }
}

export function decodeMedia(bytes: Uint8Array): Uint8Array {
  if (isPng(bytes)) return decodePng(bytes)
  if (isWav(bytes)) return decodeWav(bytes)
  throw new DisguiseError('arquivo nao e um portador reconhecido (PNG ou WAV)')
}
